import React from 'react'
import { Btn, Cnpj, SectionTitle } from '../../../../../components'
import CteParteForm from './CteParteForm'
import { ESTILO_BOTAO_PARTE } from './ctePartes.util'

const estiloDica = { color: 'gray', fontSize: 12 }

export default function SecaoPartes({
  form,
  selectedTp,
  onError,
  exibirRecebedor = true,
  destinatarioFixo = null,
  dicaDestinatarioFixo = null,
}) {
  const propsComuns = {
    ufs: form.ufs,
    selectedTp,
    carregarCidades: form.carregarCidades,
    onError,
  }

  return (
    <>
      <CteParteForm
        papel={`${form.idPrefixo}-remetente`}
        titulo="Remetente"
        parte={form.remetente}
        onChange={form.setRemetente}
        {...propsComuns}
      />

      {destinatarioFixo ? (
        <div className="p-col-12">
          <SectionTitle title="Destinatário" />
          <div
            style={{
              backgroundColor: '#e3f2fd',
              padding: '8px 10px',
              borderRadius: '5px',
              marginTop: 5,
              fontSize: 13,
            }}
          >
            <b>{destinatarioFixo.nome}</b>
            {destinatarioFixo.descricao ? ` · ${destinatarioFixo.descricao}` : ''}
            {destinatarioFixo.cnpj ? (
              <>
                {' · '}
                <Cnpj>{destinatarioFixo.cnpj}</Cnpj>
              </>
            ) : null}
          </div>
          {dicaDestinatarioFixo && <span style={estiloDica}>{dicaDestinatarioFixo}</span>}
        </div>
      ) : (
        <CteParteForm
          papel={`${form.idPrefixo}-destinatario`}
          titulo="Destinatário"
          parte={form.destinatario}
          onChange={form.setDestinatario}
          {...propsComuns}
        />
      )}

      {(!form.expedidor || (exibirRecebedor && !form.recebedor)) && (
        <div className="p-col-12">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 10,
              marginTop: 10,
            }}
          >
            <span style={estiloDica}>
              Expedidor: quem entrega a carga ao transportador (ex.: o Operador Logístico que a
              armazena); Recebedor: quem a recebe do transportador. Informe só quando forem
              diferentes do remetente e do destinatário.
            </span>
            <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
              {!form.expedidor && (
                <Btn onClick={form.adicionarExpedidor} style={ESTILO_BOTAO_PARTE}>
                  Adicionar Expedidor
                </Btn>
              )}
              {exibirRecebedor && !form.recebedor && (
                <Btn onClick={form.adicionarRecebedor} style={ESTILO_BOTAO_PARTE}>
                  Adicionar Recebedor
                </Btn>
              )}
            </div>
          </div>
        </div>
      )}

      {form.expedidor && (
        <CteParteForm
          papel={`${form.idPrefixo}-expedidor`}
          titulo="Expedidor"
          parte={form.expedidor}
          onChange={form.setExpedidor}
          onRemover={form.removerExpedidor}
          dica="Começa com os dados do Remetente; troque o que for diferente (ex.: origem Operador Logístico cadastrado). O início da prestação segue a cidade do expedidor."
          {...propsComuns}
        />
      )}
      {form.recebedor && (
        <CteParteForm
          papel={`${form.idPrefixo}-recebedor`}
          titulo="Recebedor"
          parte={form.recebedor}
          onChange={form.setRecebedor}
          onRemover={form.removerRecebedor}
          dica="Começa com os dados do Destinatário; troque o que for diferente. O fim da prestação segue a cidade do recebedor."
          {...propsComuns}
        />
      )}
    </>
  )
}
